import { SxProps } from '@mui/material'
import { Theme } from '@mui/material/styles'

export const typographyStyle = {
  fontWeight: 500,
  marginBottom: '5px',
}

export const filtersHeaderStyle = {
  flexDirection: 'row',
  alignItems: 'center',
  spacing: 1,
}

export const filtersCounterTextStyle: SxProps<Theme> = {
  display: 'inline',
  color: (theme) => theme.palette.primary.main,
  fontSize: 'small',
  marginLeft: 1,
}
